import React from 'react';
import MaterialDialogContentText from '@mui/material/DialogContentText';
import type {DialogContentTextProps as MaterialDialogContentTextProps} from '@mui/material/DialogContentText';

export type ModalContentTextProps = MaterialDialogContentTextProps;

export const ModalContentText = React.forwardRef<any, ModalContentTextProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <MaterialDialogContentText
                ref={ref}
                {...props}
            >
                {children}
            </MaterialDialogContentText>
        );
    });

ModalContentText.displayName = 'ModalContentText';
